export const AUSD_ADDRESS = '0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a';
export const ASSET_TICKER = 'AUSD';
export const ICON_SRC = 'https://sdk-cdn.fun.xyz/images/ausd.svg';
